// Soaki product card: hover image swap and in-card image arrows. A custom element, so cards that are inserted
// later (load more, facet re-renders, quick view) are initialised without any extra wiring.
if (!customElements.get('soaki-product-card')) {
  customElements.define(
    'soaki-product-card',
    class SoakiProductCard extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.layers = Array.from(this.querySelectorAll('[data-card-layer]'));
        if (this.layers.length < 2) return;
        this.initialised = true;

        this.status = this.querySelector('[data-card-status]');
        this.template = this.status?.dataset.template || '';
        this.hoverSwap = this.dataset.hoverSwap === 'true';
        this.current = 0;

        this.addEventListener('mouseenter', () => {
          if (this.hoverSwap && window.matchMedia('(hover: hover)').matches && this.current === 0) this.show(1, false);
        });
        this.addEventListener('mouseleave', () => {
          if (this.current !== 0) this.show(0, false);
        });

        this.querySelectorAll('[data-card-step]').forEach((button) => {
          button.addEventListener('click', () => {
            const step = Number(button.dataset.cardStep) || 1;
            this.show((this.current + step + this.layers.length) % this.layers.length, true);
          });
        });
      }

      show(index, announce) {
        this.current = index;
        this.layers.forEach((layer, i) => layer.classList.toggle('is-active', i === index));
        if (!this.status) return;
        this.status.textContent = announce ? this.template.replace('__index__', String(index + 1)) : '';
      }
    }
  );
}
